export const getEbayAccessTokenFromCookie = () => {
    // if our environment variable ENVIRONMENT is set to 'local'
    console.log("abc2 starting get ebay access token from cookie");
    if (process.env?.REACT_APP_ENVIRONMENT && process.env.REACT_APP_ENVIRONMENT === 'local') {
        console.log("abc2 environment is local");
        return process.env.REACT_APP_EBAY_TOKEN;
    }
    // else get the token from the cookie
    console.log("abc2 environment is not local");
    const cookie = document.cookie.split(';').find(row => row.startsWith('ebayAccessToken='));
    return cookie ? cookie.split('=')[1] : null;
};

